import React from 'react';

import { Link } from 'react-router-dom';
import { Layout } from 'components/organisms/layout';
import { ContentsTitle, LeadContents, } from 'components/molecules';
/** styles **/
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import { Comics } from 'components/organisms/comics';
import { WhatIsPman, PossibleItems, OurFutures, Equipment, Concept, Member } from 'components/organisms';
import s from '../styles/pages/about.module.scss';

export const About: React.FC = () => {
  return (
    <Layout>
      <div className={s.aboutPageWrapper}>
        <ContentsTitle className={s.contentsTitle} title="WHAT'S P-man" subTitle="ピーマンとは" />
        <div className={s.aboutContent}>

          <WhatIsPman />
          <div id="items">
            <PossibleItems />
          </div>
          <div id="features">
            <OurFutures />
          </div>

          <div id="equipment">
            <Equipment />
          </div>
          <div id="concept">
            <Concept />
          </div>
          <div id="member">
            <Member />
          </div>
        </div>

        <LeadContents
          className={s.leadContents}
          gaActionName="サポーター登録ボタンクリック(ご登録いただいたサポーターの声)"
        >
          <h3>あなたの ”あったらいいな” が現実になるかも？</h3>
          <p>
            応募にはサポーター登録をしていただく必要がございます。サポーター様にはイベントのご案内やいち早く最新情報をお届けします。
          </p>
          <p>※ 提供有無は物件によって異なります</p>
        </LeadContents>
        <Link className={s.topLink} to="/">
          <BlackCircleArrow className={s.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};